var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.data.item.active === true)?_c('span',{staticClass:"badge badge-success"},[_vm._v(" "+_vm._s(_vm.$t("general.active")))]):_c('span',{staticClass:"badge badge-danger"},[_vm._v(" "+_vm._s(_vm.$t("general.inactive")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }